export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.project-center': '專案管理',
  'menu.project-center.workbench': '工作臺',
  'menu.project-center.project-overview': '專案總覽',
  'menu.project-center.project-space': '專案空間',
  'menu.project-center.my-tasks': '我的任務',
  'menu.project-center.my-projects': '我的專案',
  'menu.project-center.dashboard': '問題中心',
  'menu.project-center.boards': '全域看板',
  'menu.project-center.gantt': '全域甘特圖',
  'menu.project-center.projects': '專案列表',
  'menu.project-center.resources': '資源中心',
  'menu.project-center.calendar': '日曆',
  'menu.project-center.risks': '風險中心',
  'menu.project-center.analytics': '數據分析',
  'menu.template-center': '模板中心',
  'menu.template-center.detail': '模板詳情',
  'menu.system': '系統設置',
  'menu.system.permissions': '權限管理',
  'menu.system.dictionary': '數據字典',
  'menu.system.ai-model-binding': '模型綁定',
  'menu.project-center.project-detail': '專案工作區',
  'menu.project-center.project-detail.overview': '專案總覽',
  'menu.project-center.project-detail.kanban': '任務管理',
  'menu.project-center.project-detail.gantt': '專案進度',
  'menu.project-center.project-detail.delivery': '文件資料',
  'menu.project-center.project-detail.acceptance': '驗收',
  'menu.project-center.project-detail.communication': '溝通',
  'menu.project-center.project-detail.members': '成員協作',
  'menu.project-center.project-detail.work-hours': '專案統計',
  'menu.project-center.project-detail.issues': '風險問題',
  'menu.project-center.project-detail.report': '專案匯報',
  'menu.project-center.project-detail.review': '復盤',
  'menu.project-center.project-detail.activities': '專案動態',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
